<template>
  <van-list v-model="loading" :finished="finished" finished-text="暂无记录" @load="onLoad">
    <van-cell v-for="item in list" :key="item" style="padding: 5px;">
      <template>
        <div class="div_list" @click="payInfo(item.id)">
          <div>
            <div class="div_left">
              {{item.type==0?"充值":item.type==1?"退款":item.type==7?"充值赠送":"消费"}}
            </div>
            <div class="div_right font_orange" v-if="item.money>0">+{{item.money}}</div>
            <div class="div_right font_bold" v-if="item.money<0">{{item.money}}</div>
            <div class="div_clear"></div>
          </div>
          <div>
            <div class="div_left">{{item.recordTime}}</div>
            <div class="div_right">余额：{{item.balance}}</div>
            <div class="div_clear"></div>
          </div>
        </div>
      </template>
    </van-cell>
  </van-list>
</template>

<script>
    import { mySessionStorage } from '@/utils/storage.js'
  export default {
    data() {
      return {
        list: [],
        loading: false,
        finished: false,
        userId: "",
        isNull:false
      };
    },
    methods: {
      onLoad() {
        // 异步更新数据
        // setTimeout 仅做示例，真实场景中一般为 ajax 请求
        this.$http.post(this.$api.walletDetail + "/" + this.userId, {
          ...this.query
        }).then(res => {
          if(res.data.length==0){
            this.finished = true;
          }else{
            this.finished = false;
            this.list = res.data;
          }
        });
        this.loading = false;
      },
      payInfo(id){
          this.$router.push({path:"/detailInfo",query:{"id":id}});
      }
    },created() {
      this.userId = this.$route.query.userId;
    }
  };
</script>

<style>
  .div_left {
    float: left;
  }

  .div_right {
    float: right;
  }

  .div_clear {
    clear: both;
  }

  .div_list {
    padding: 2% 1%;
    background: whitesmoke;
  }

  .font_orange {
    font-weight: bold;
    color: orange;
  }

  .font_bold {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/wallet/detail.vue